export default "__VITE_ASSET__DC7NDC_6__"